<template>
    <div>
        <b-modal
            no-close-on-backdrop
            @ok="handleOk"
            v-model="valueModal"
            @close="valueModal = false"
            title="Additional Information"
            size="xl"
            id="modal-create-booking-sale-new"
            hide-footer
            @ok-clicked="closeModal"
        >
            <template #modal-title>
                <div class="header-title text-white text-uppercase h4">
                    Create a new booking in just a few steps
                </div>
                <div class="header-sub text-white">
                    Please fill in the data completely and correctly to receive
                    the fastest booking confirmation
                </div>
            </template>
            <b-tabs v-if="valueModal" pills card>
                <b-tab
                    :title="'Booking Request'"
                    :active="activeTabAll == 0"
                    @click.prevent="activeTabAll = 0"
                    v-if="request_quotation != null"
                >
                    <b-card-text>
                        <!-- <vue-perfect-scrollbar
                            :settings="{
                                maxScrollbarLength: 150,
                                suppressScrollX: true,
                            }"
                            style="height: 75vh"
                        > -->
                        <request-quotation
                            ref="requestBookingNoteRef"
                            @ok-clicked="closeModal"
                            :createdRequestQuotation="request_quotation"
                            :readonlyService="true"
                            :isCustomer="false"
                            :readonly="step == 10 ? false : step != 1"
                            step="booking"
                            @onServiceType="onServiceType"
                        />
                        <!-- </vue-perfect-scrollbar> -->
                    </b-card-text>
                </b-tab>
                
                
                
                
                

                <!-- RequestBookingNote -->
                <!-- <b-tab
                    title="Booking Note information"
                    :active="activeTabAll == 1"
                    @click.prevent="activeTabAll = 1"
                    :disabled="step == 10 ? false : step <= 1"
                    v-if="request_quotation != null && booking_note != null"
                >
                    <b-card-text>
                        <vue-perfect-scrollbar
                            :settings="{
                                maxScrollbarLength: 150,
                                suppressScrollX: true,
                            }"
                            style="max-height: 70vh"
                            class="scrollable-container scroll-area"
                        >
                            <RequestBookingNote
                                :bookingSchedule="true"
                                ref="refBookingNote"
                                :key="countReload"
                                @clickActiveTab="activeTabAll = 2"
                                v-model="booking_note"
                                :readonly="step == 10 ? false : step != 2"
                                :request_quotation="{}"
                                :readonlyService="true"
                            />
                        </vue-perfect-scrollbar>
                    </b-card-text>
                </b-tab> -->
            
                <b-tab
                    title="Quote"
                    @click.prevent="activeTabAll = 2"
                    :disabled="step == 10 ? false : step <= 2"
                    v-if="isServiceType == true"
                    :active="activeTabAll == 2"
                    
                >
                    <b-card-text :key="reload">
                        <create-quotation
                            :request_quotation="request_quotation"
                            :booking="quotation"
                            :view_quotation="quotation"
                            :key="reload"
                            @ok-clicked="closeModal"
                            :readonly="step == 10 ? false : step != 3"
                            ref="newBookingNoteRef"
                            :serviceType="
                                step == 10
                                    ? null
                                    : {
                                          service_type:
                                              request_quotation.service_type,
                                          company_id:
                                              request_quotation.company_id,
                                      }
                            "
                            step="booking"
                        />
                    </b-card-text>
                </b-tab>

                <!-- <b-tab
                    title="Document"
                    @click.prevent="activeTabAll = 3"
                    :disabled="!request_quotation.id ? true : step <= 3"
                    :active="activeTabAll == 3"
                >
                    <b-row>
                        <b-col cols="12" class="border-bottom">
                            <vue-dropzone
                                ref="addFile"
                                id="addFile"
                                :options="dropzoneOptions"
                                :useCustomSlot="true"
                                :include-styling="false"
                                v-on:vdropzone-success="uploadSuccess"
                                v-on:vdropzone-error="vdropzoneError"
                            >
                                <div class="dropzone-custom-content">
                                    <b-button
                                        variant="primary"
                                        class="btn-sm float-right my-1"
                                    >
                                        <feather-icon icon="PlusIcon" /> Add
                                        File
                                    </b-button>
                                </div>
                            </vue-dropzone>
                        </b-col>
                    </b-row>
                    <vue-perfect-scrollbar
                        :settings="{
                            maxScrollbarLength: 150,
                            suppressScrollX: true,
                        }"
                        style="height: 70vh"
                        class="scrollable-container scroll-area pb-5"
                    >
                        <b-card-text>
                            <vue-good-table
                                :columns="document_columns"
                                :rows="document_rows"
                                :line-numbers="true"
                                class="mb-5"
                            >
                                <template slot="table-row" slot-scope="props">
                                    
                                    <span
                                        v-if="props.column.field === 'username'"
                                    >
                                        {{ props.row.username }}
                                    </span>
                                    <span
                                        v-else-if="
                                            props.column.field === 'action'
                                        "
                                    >
                                        <a
                                            v-if="
                                                checkInput(
                                                    props.row.text,
                                                    typeView
                                                )
                                            "
                                        >
                                            <feather-icon
                                                @click="viewFile(props.row)"
                                                icon="EyeIcon"
                                            />
                                        </a>
                                        <a
                                            class="ml-1"
                                            :href="props.row.download_path"
                                        >
                                            <feather-icon icon="DownloadIcon" />
                                        </a>

                                        <a
                                            v-if="
                                                userData.username ==
                                                    props.row.username ||
                                                userData.username == 'admin'
                                            "
                                            class="ml-1 text-danger"
                                            @click="removeFile(props.row)"
                                        >
                                            <feather-icon icon="DeleteIcon" />
                                        </a>
                                    </span>

                                    
                                    <span v-else>
                                        {{
                                            props.formattedRow[
                                                props.column.field
                                            ]
                                        }}
                                    </span>
                                </template>
                            </vue-good-table>
                        </b-card-text>
                    </vue-perfect-scrollbar>
                </b-tab> -->
            </b-tabs>
            <div class="container_btn" v-if="step == 1">
                <button class="custom_btn_booking" @click="showModalComingSoon">Preview</button>
                <button @click="handleOk" class="custom_btn_booking">Submit</button>
            </div>
        </b-modal>
        <b-modal
      v-model="ModalComingSoon"
      no-close-on-backdrop
      @close="ModalComingSoon = false"
      dialog-class="new-dialog-modal-reject"
      header-class="new-modal-reject"
      title=""
      hide-footer
    >
      <template #modal-title>
        <div class="header-title-reject">
         
          COMING SOON
        </div>
      </template>
      <div class="custom_text_coming">
      THIS FEATURE IS COMING SOON
      </div>
    </b-modal>
        <b-modal id="file-notes" title="Add File" size="lg" hide-footer>
            <b-card-text>
                <p>File: {{ nameFile }}</p>

                <b-form-group>
                    <label>Notes</label>
                    <b-form-textarea rows="4" v-model="notes"></b-form-textarea>
                </b-form-group>

                <b-button
                    @click="saveFile"
                    variant="primary"
                    class="btn-sm float-right my-1"
                    >Save</b-button
                >
            </b-card-text>
        </b-modal>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import { $ctx } from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment";
import { mapState } from "vuex";

import {
    BCardText,
    BButton,
    BModal,
    BFormGroup,
    BTabs,
    BTab,
} from "bootstrap-vue";
export default {
    components: {
        BCardText,
        BButton,
        BModal,
        BFormGroup,
        BTabs,
        BTab,
        CreateQuotation: () =>
            import("@/views/wr1/quotation/CreateQuotation.vue"),
        RequestQuotation: () =>
            // import("@/views/wr1/quotation/RequestQuotation.vue"),
            import("@/views/wr1/V2/NewBookingSale/index.vue"),
        // import("@/views/wr1/V2/NewContainerTruckSale/index.vue"),
        vueDropzone: vue2Dropzone,
        RequestBookingNote: () =>
            import("@/views/wr1/booking-note/RequestBookingNote.vue"),
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        currentItem: {
            type: Object,
            default: () => {
                return {};
            },
        },
        step: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        valueModal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        isCustomer() {
            return this.getWr1();
        },
        exchangeRate: function () {
            return this.$store.getters["masterData/exchangeRate"];
        },
        ...mapState("masterData", ["quotations"]),
    },
    data() {
        return {
            ModalComingSoon:false,
            booking_note: {
                shipping_line: null,
                company_id: null,
                company_name: null,
                customer_name: null,
                sale_name: null,
                vessel_name: null,
                pol_name: null,
                pod_name: null,
                placeOfDelivery_name: null,
                goods_type_name: null,
                service_type: "3",
                vessel: null,
                customer_id: null,
                customer_email: null,
                sale_id: null,
                booking_date: new Date(),
                booking_no: null,
                place_of_stuffing: null,
                contact: "Mr HAI : 0938.108.990",
                closing_time: null,
                cut_si_vgm: null,
                pol_port: null,
                pod_port: null,
                placeOfDelivery: null,
                eta: null,
                etd: null,
                goods_type: null,
                packageNumber: null,
                trong_luong: null,
                so_khoi: null,
                note: `1. Please contact our operation 2 hours before loading cargo to stuffing place.
2. Please bring a booking note, declaration, barcode, vgm.
3. Wooden packages & wooden products must be fumigated at shipper's premise.
4. Shipping mark on the surface of all crate/carton/case is shipper's responsibility to attach.
5. Our services such as warehouse, trucking, trailer, and customs clearance, are always available to provide by our own facility. Please keep in contact for any requirements.
6. The cargo which is classified as dangerous, foodstuff, personal effects, over 580 cm length/pkg, over 500kgs/pkg, or required special treatments which are limited for sea transportation have to be informed to WR1 before booking.
7. For European trade lane: HS code of cargo required to provide at least two days before ETD.
8. For US/Canada trade lanes: No personal effects are accepted.
9. If the consignee refuses to collect cargo and pay destination charges, all arising expenses and destination charges due to abandoning and/or destroying cargo will be debited to the shipper's account.

In case you and/or your relevant parties fail to declare the mentioned request with WR1, all extra arising charges will be debited to your account.`,
            },
            request_quotation: {},
            quotation: {},
            booking: {},
            type: true,
            base64: "",
            customer_list_options: [],
            typeView: ["png", "jpg", "pdf", "jpeg", "gif", "bmp"],
            typeViewImg: ["png", "jpg", "jpeg", "gif", "bmp"],

            nameFile: "",
            responseFileUp: "",
            notes: "",
            file: "",
            dropzoneOptions: {
                url: $ctx.API_URL + "uploadFile",
                previewsContainer: false,
                createImageThumbnails: false,
                acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
                destroyDropzone: true,
                maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
                maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
                headers: { apiKey: localStorage.getItem("accessToken") },
            },
            appLogoImage: require("@/assets/images/logo/logo.svg"),
            userData: JSON.parse(localStorage.getItem("userData")),

            document_columns: [
                {
                    label: "Date",
                    field: "date",
                    width: "100px",
                    tdClass: "text-center",
                    filterOptions: { enabled: true },
                },
                {
                    label: "Name",
                    field: "fullName",
                    width: "120px",
                    tdClass: "text-center",
                    filterOptions: { enabled: true },
                },
                {
                    label: "File name",
                    field: "text",
                    filterOptions: { enabled: true },
                },
                {
                    label: "Notes",
                    field: "notes",
                    filterOptions: { enabled: true },
                },
                {
                    label: "Action",
                    width: "120px",
                    tdClass: "text-center",
                    field: "action",
                },
            ],
            document_rows: [],
            activeForm: true,
            activeTabAll: 0,
            isServiceType: true,
            serviceType: null,
            currentData: null,
            reload: 1,
            idBooking: null,
            countReload: 0,
        };
    },
    mounted() {
        if (this.step == 10) {
            this.$loading.show();
        }

        if (this.currentItem) {
            this.currentData = this.currentItem;

            this.request_quotation = { ...this.currentItem };
            this.request_quotation.customer_id = "";
            setTimeout(() => {
                if (!!this.$refs.requestBookingNoteRef) {
                    this.request_quotation.contact = this.currentItem.contact;
                    this.request_quotation.customer_id = "";

                    this.request_quotation.service_type =
                        this.currentItem.service_type_id;
                    this.request_quotation.shipping_line =
                        this.currentItem.carrier_id;
                    this.request_quotation.eta = this.currentItem.eta;
                    this.request_quotation.etd = this.currentItem.etd;
                    this.request_quotation.pod_port = this.currentItem.pod_code;
                    this.request_quotation.pol_port = this.currentItem.pol_code;
                    this.request_quotation.trong_luong =
                        this.booking_note.trong_luong;
                    this.request_quotation.cargo_ready =
                        moment().format("DD/MM/YY HH:mm");
                    this.request_quotation.cut_si_vgm =
                        this.currentItem.doc_cut_off;
                    this.request_quotation.closing_time =
                        this.currentItem.cargo_cut_off;
                    this.request_quotation.vessel_name =
                        this.currentItem.load_vessel;
                    this.request_quotation.place_of_stuffing =
                        this.currentItem.stuffing_place_id;
                    this.request_quotation.pol_name = this.currentItem.pol;
                    this.request_quotation.pod_name = this.currentItem.pod;
                }
                // copy bookings
                if (this.step == 10) {
                    this.booking_note =
                        this.request_quotation.booking_note != null
                            ? this.request_quotation.booking_note
                            : this.booking_note;
                    // "{"booking_id":"WR1231222000005","shipping_line":44,"company_id":"0303957341","company_name":null,"customer_name":"Lương Thiện","sale_name":null,"vessel_name":null,"pol_name":"KIMITSU, JAPAN","pod_name":"KHO CFS PHU HUU (02CIS04)","placeOfDelivery_name":null,"goods_type_name":null,"service_type":"3","vessel":5,"customer_id":"thien.test","customer_email":"luongthiena123444z@gmail.com","sale_id":"cuongnh@wr1.com.vn","booking_date":"23/12/22 01:15","booking_no":null,"place_of_stuffing":3,"contact":"01237821293 DRAKE","closing_time":"21/11/22 00:00","cut_si_vgm":"25/11/22 00:00","pol_port":" JPKMT","pod_port":"02CIS04","placeOfDelivery":null,"eta":"24/11/22","etd":"07/01/23","goods_type":"53","trong_luong":null,"so_khoi":null,"note":"1. Please contact our operation 2 hours before loading cargo to stuffing place.\n2. Please bring a booking note, declaration, barcode, vgm.\n3. Wooden packages & wooden products must be fumigated at shipper's premise.\n4. Shipping mark on the surface of all crate/carton/case is shipper's responsibility to attach.\n5. Our services such as warehouse, trucking, trailer, and customs clearance, are always available to provide by our own facility. Please keep in contact for any requirements.\n6. The cargo which is classified as dangerous, foodstuff, personal effects, over 580 cm length/pkg, over 500kgs/pkg, or required special treatments which are limited for sea transportation have to be informed to WR1 before booking. \n7. For European trade lane: HS code of cargo required to provide at least two days before ETD.\n8. For US/Canada trade lanes: No personal effects are accepted.\n9. If the consignee refuses to collect cargo and pay destination charges, all arising expenses and destination charges due to abandoning and/or destroying cargo will be debited to the shipper's account.\n\nIn case you and/or your relevant parties fail to declare the mentioned request with WR1, all extra arising charges will be debited to your account.","id":"WR1S042212028"}"
                    delete this.booking_note.id;
                    delete this.booking_note.booking_id;

                    this.request_quotation.customer_id =
                        this.currentItem.customer_id;
                    this.request_quotation.service_type = "3";

                    this.quotation = this.request_quotation.quotation;
                    this.quotation ? delete this.quotation.id : "";

                    this.$loading.hide();

                    this.reload++;
                }
            }, 300);
        }
    },
    methods: {
        showModalComingSoon(){
            this.ModalComingSoon = true
        },
        closeModal(){
            this.$loading.hide()
            this.valueModal = false
        },
        async handleOk(event) {
            event.preventDefault();
            if (this.step == 10) {
                var validate =
                    await this.$refs.requestBookingNoteRef.$refs.bcRules
                        .validate()
                        .then((success) => {
                            return success;
                        });

                if (!validate) {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: "Please enter customer & service!",
                            icon: "AlertTriangleIcon",
                            variant: "warning",
                        },
                    });
                    return;
                }
                validate =
                    await this.$refs.requestBookingNoteRef.$refs.requestQuotationRules
                        .validate()
                        .then((success) => {
                            return success;
                        });

                if (!validate) {
                    this.activeTab = 0;
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: "Please check the requested information data!",
                            icon: "AlertTriangleIcon",
                            variant: "warning",
                        },
                    });
                    return;
                }

                validate =
                    await this.$refs.refBookingNote.$refs.bcRulesBookingNote
                        .validate()
                        .then((success) => {
                            return success;
                        });

                if (!validate) {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: this.$i18n.t("notifyFormError"),
                            icon: "AlertTriangleIcon",
                            variant: "warning",
                        },
                    });
                    return;
                }

                this.$refs.requestBookingNoteRef.$data.request_quotation.files =
                    [];
                //Lấy các file của request a quotation
                for (
                    var i = 0;
                    i <
                    this.$refs.requestBookingNoteRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()
                        .length;
                    i++
                ) {
                    var file = JSON.parse(
                        this.$refs.requestBookingNoteRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
                            i
                        ].xhr.response
                    ).result;
                    file.size =
                        this.$refs.requestBookingNoteRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
                            i
                        ].size;
                    file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
                    file.uuid =
                        this.$refs.requestBookingNoteRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
                            i
                        ].upload.uuid;

                    file.fullName = this.userData.fullName;
                    file.username = this.userData.username;
                    this.$refs.requestBookingNoteRef.$data.request_quotation.files.push(
                        file
                    );
                }

                this.request_quotation =
                    this.$refs.requestBookingNoteRef.$data.request_quotation;

                let t = 0;
                let totalVatVnd = 0;
                let totalVatUsd = 0;
                let vatVND = 0;
                let vatUSD = 0;
                let totalVND = 0;
                let totalUSD = 0;

                this.$refs.newBookingNoteRef.$data.currencies.forEach((e) => {
                    t += this.$refs.newBookingNoteRef.getTotal(e.id);

                    if (e.id == "USD") {
                        totalVatUsd +=
                            this.$refs.newBookingNoteRef.getTotalGrandTotal(
                                e.id
                            );
                        vatUSD += this.$refs.newBookingNoteRef.getTotalVAT(
                            e.id
                        );
                        totalUSD += this.$refs.newBookingNoteRef.getTotal(e.id);
                    } else {
                        totalVatVnd +=
                            this.$refs.newBookingNoteRef.getTotalGrandTotal(
                                e.id
                            );
                        vatVND += this.$refs.newBookingNoteRef.getTotalVAT(
                            e.id
                        );
                        totalVND += this.$refs.newBookingNoteRef.getTotal(e.id);
                    }
                });

                const cost_total = {
                    exchange_rate: this.exchangeRate,
                    total: totalUSD * this.exchangeRate + totalVND,
                    vat: vatUSD * this.exchangeRate + vatVND,
                    total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
                };
                this.$refs.newBookingNoteRef.$data.quotation.costs =
                    this.$refs.newBookingNoteRef.$data.costs;
                this.$refs.newBookingNoteRef.$data.quotation.cost_total =
                    cost_total;
                this.$refs.newBookingNoteRef.$data.quotation.commission =
                    this.$refs.newBookingNoteRef.$data.commission;
                this.request_quotation =
                    this.$refs.requestBookingNoteRef.$data.request_quotation;

                this.$loading.show();

                useJwt
                    .post("wr1?objectType=RequestWr1Booking", {
                        request_quotation:
                            this.$refs.requestBookingNoteRef.$data
                                .request_quotation,
                        quotation: {
                            ...this.$refs.newBookingNoteRef.$data.quotation,
                            createdBy: this.userData.username,
                            createDate: moment(new Date()).format("DD/MM/YYYY"),
                        },
                    })
                    .then((response) => {
                        if (response.data.result == "1") {
                            this.request_quotation.id =
                                response.data.meta.bookingId;

                            this.postBookingNote();

                            this.valueModal = false;
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: this.$i18n.t("bookingSaleSuccess"),
                                    icon: "CheckSquareIcon",
                                    variant: "primary",
                                },
                            });
                            this.$emit("EditBookingEvent");
                        }
                    })
                    .catch((error) => {
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Booking Request Error",
                                icon: "AlertTriangleIcon",
                                variant: "danger",
                            },
                        });
                    })
                    .finally(() => this.$loading.hide());
            } else {
                if (this.step == 1) {
                    var validate =
                        // await  this.$refs.requestBookingNoteRef.$refs.bcRules
                        await this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.LCLBookingSaleCustomer.$refs.validateCustomer
                            .validate()
                            .then((success) => {
                                return success;
                            });

                    if (!validate) {
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Please enter customer & service!",
                                icon: "AlertTriangleIcon",
                                variant: "warning",
                            },
                        });
                        return;
                    }

                    validate =
                        // await this.$refs.requestBookingNoteRef.$refs.requestQuotationRules
                        await this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.Routing.$refs.validateRouting
                            .validate()
                            .then((success) => {
                                return success;
                            });

                    if (!validate) {
                        this.activeTab = 0;
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Please check the requested Routing Details data!",
                                icon: "AlertTriangleIcon",
                                variant: "warning",
                            },
                        });
                        return;
                    }
                    validate =
                        // await this.$refs.requestBookingNoteRef.$refs.requestQuotationRules
                        await this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.Sailing.$refs.validateSailing
                            .validate()
                            .then((success) => {
                                return success;
                            });

                    if (!validate) {
                        this.activeTab = 0;
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Please check the requested Sailing Schedule data!",
                                icon: "AlertTriangleIcon",
                                variant: "warning",
                            },
                        });
                        return;
                    }
                    validate =
                        // await this.$refs.requestBookingNoteRef.$refs.requestQuotationRules
                        await this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.Cargo.$refs.validateCargo
                            .validate()
                            .then((success) => {
                                return success;
                            });

                    if (!validate) {
                        this.activeTab = 0;
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Please check the requested Cargo Detail data!",
                                icon: "AlertTriangleIcon",
                                variant: "warning",
                            },
                        });
                        return;
                    }
                    if (
                        !this.$refs.requestBookingNoteRef.$data
                            .request_quotation.collect &&
                        !this.$refs.requestBookingNoteRef.$data
                            .request_quotation.prepaid
                    ) {
                        this.activeTab = 0;
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Please check the requested Freight Term data!",
                                icon: "AlertTriangleIcon",
                                variant: "warning",
                            },
                        });
                        return;
                    }
                    if (
                        !this.$refs.requestBookingNoteRef.$data
                            .request_quotation.stack_able &&
                        !this.$refs.requestBookingNoteRef.$data
                            .request_quotation.non_stack_able &&
                        !this.$refs.requestBookingNoteRef.$data
                            .request_quotation.rotatable
                    ) {
                        this.activeTab = 0;
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Please check the requested Sailing Schedule data!",
                                icon: "AlertTriangleIcon",
                                variant: "warning",
                            },
                        });
                        return;
                    }
                    // validate =
                    //     await this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.Freight.$refs.validateFreight
                    //         .validate()
                    //         .then((success) => {
                    //             return success;
                    //         });

                    // if (!validate) {
                    //     this.activeTab = 0;
                    //     this.$toast({
                    //         component: ToastificationContent,
                    //         props: {
                    //             title: "Please check the requested Freight Term data!",
                    //             icon: "AlertTriangleIcon",
                    //             variant: "warning",
                    //         },
                    //     });
                    //     return;
                    // }

                    this.$refs.requestBookingNoteRef.$data.request_quotation.files =
                        [];
                    //Lấy các file của request a quotation
                    for (
                        var i = 0;
                        i <
                        this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
                            .length;
                        i++
                    ) {
                        var file = JSON.parse(
                            this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                                i
                            ].xhr.response
                        ).result;
                        file.size =
                            this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                                i
                            ].size;
                        file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
                        file.uuid =
                            this.$refs.requestBookingNoteRef.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                                i
                            ].upload.uuid;

                        file.fullName = this.userData.fullName;
                        file.username = this.userData.username;
                        this.$refs.requestBookingNoteRef.$data.request_quotation.files.push(
                            file
                        );
                    }

                    this.request_quotation =
                        this.$refs.requestBookingNoteRef.$data.request_quotation;
                    // console.log(
                    //     "run here ",
                    //     this.$refs.requestBookingNoteRef.$data.request_quotation
                    // );
                    // let t = 0;
                    // let totalVatVnd = 0;
                    // let totalVatUsd = 0;
                    // let vatVND = 0;
                    // let vatUSD = 0;
                    // let totalVND = 0;
                    // let totalUSD = 0;

                    // this.$refs.newBookingNoteRef.$data.currencies.forEach(
                    //     (e) => {
                    //         t += this.$refs.newBookingNoteRef.getTotal(e.id);

                    //         if (e.id == "USD") {
                    //             totalVatUsd +=
                    //                 this.$refs.newBookingNoteRef.getTotalGrandTotal(
                    //                     e.id
                    //                 );
                    //             vatUSD +=
                    //                 this.$refs.newBookingNoteRef.getTotalVAT(
                    //                     e.id
                    //                 );
                    //             totalUSD +=
                    //                 this.$refs.newBookingNoteRef.getTotal(e.id);
                    //         } else {
                    //             totalVatVnd +=
                    //                 this.$refs.newBookingNoteRef.getTotalGrandTotal(
                    //                     e.id
                    //                 );
                    //             vatVND +=
                    //                 this.$refs.newBookingNoteRef.getTotalVAT(
                    //                     e.id
                    //                 );
                    //             totalVND +=
                    //                 this.$refs.newBookingNoteRef.getTotal(e.id);
                    //         }
                    //     }
                    // );

                    // const cost_total = {
                        //     exchange_rate: this.exchangeRate,
                        //     total: totalUSD * this.exchangeRate + totalVND,
                        //     vat: vatUSD * this.exchangeRate + vatVND,
                        //     total_vat:
                            //         totalVatUsd * this.exchangeRate + totalVatVnd,
                    // };
                    // this.$refs.newBookingNoteRef.$data.quotation.costs =
                    //     this.$refs.newBookingNoteRef.$data.costs;
                    // this.$refs.newBookingNoteRef.$data.quotation.cost_total =
                    //     cost_total;
                    // this.$refs.newBookingNoteRef.$data.quotation.commission =
                    //     this.$refs.newBookingNoteRef.$data.commission;
                    // this.request_quotation =
                    //     this.$refs.requestBookingNoteRef.$data.request_quotation;
                    if (this.request_quotation.quotation){
                        const temp =
                        this.quotations.find(
                            (e) => e.id == this.request_quotation.quotation
                            ).quotation_info || {};
                            this.quotation = JSON.parse(temp);
                        }
                    this.reload++;
                    this.activeTabAll = 2;
                    this.step = 3;
                    // this.$loading.show();
                    // useJwt
                    //     .post("wr1?objectType=RequestWr1Booking", {
                    //         request_quotation:
                    //             this.$refs.requestBookingNoteRef.$data
                    //                 .request_quotation,
                    //         quotation: {
                    //             ...this.$refs.newBookingNoteRef.$data.quotation,
                    //             createdBy: this.userData.username,
                    //             createDate: moment(new Date()).format(
                    //                 "DD/MM/YYYY"
                    //             ),
                    //         },
                    //     })
                    //     .then((response) => {
                    //         if (response.data.result == "1") {
                    //             this.request_quotation.id =
                    //                 response.data.meta.bookingId;
                    //             this.activeTabAll = 2;
                    //             this.step = 3;
                    //             // this.loadBookingNote();
                    //             this.$toast({
                    //                 component: ToastificationContent,
                    //                 props: {
                    //                     title: "Booking Request Successfully",
                    //                     icon: "CheckSquareIcon",
                    //                     variant: "primary",
                    //                 },
                    //             });
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         this.$toast({
                    //             component: ToastificationContent,
                    //             props: {
                    //                 title: "Booking Request Error",
                    //                 icon: "AlertTriangleIcon",
                    //                 variant: "danger",
                    //             },
                    //         });
                    //     })
                    //     .finally(() => this.$loading.hide());

                    
                } else if (this.step == 2) {
                    var validate =
                        await this.$refs.refBookingNote.$refs.bcRulesBookingNote
                            .validate()
                            .then((success) => {
                                return success;
                            });

                    if (!validate) {
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: this.$i18n.t("notifyFormError"),
                                icon: "AlertTriangleIcon",
                                variant: "warning",
                            },
                        });
                        return;
                    }
                   
                    this.postBookingNote();
                    this.reload++;
                    this.step = 3;
                    this.activeTabAll = 2;
                    
                } else if (this.step == 3) {
                    let t = 0;
                    let totalVatVnd = 0;
                    let totalVatUsd = 0;
                    let vatVND = 0;
                    let vatUSD = 0;
                    let totalVND = 0;
                    let totalUSD = 0;
                    
                    this.$refs.newBookingNoteRef.$data.currencies.forEach(
                        (e) => {
                            t += this.$refs.newBookingNoteRef.getTotal(e.id);

                            if (e.id == "USD") {
                                totalVatUsd +=
                                    this.$refs.newBookingNoteRef.getTotalGrandTotal(
                                        e.id
                                    );
                                vatUSD +=
                                    this.$refs.newBookingNoteRef.getTotalVAT(
                                        e.id
                                    );
                                totalUSD +=
                                    this.$refs.newBookingNoteRef.getTotal(e.id);
                            } else {
                                totalVatVnd +=
                                    this.$refs.newBookingNoteRef.getTotalGrandTotal(
                                        e.id
                                    );
                                vatVND +=
                                    this.$refs.newBookingNoteRef.getTotalVAT(
                                        e.id
                                    );
                                totalVND +=
                                    this.$refs.newBookingNoteRef.getTotal(e.id);
                            }
                        }
                    );
                    
                    const cost_total = {
                        exchange_rate: this.exchangeRate,
                        total: totalUSD * this.exchangeRate + totalVND,
                        vat: vatUSD * this.exchangeRate + vatVND,
                        total_vat:
                            totalVatUsd * this.exchangeRate + totalVatVnd,
                    };
                    this.$refs.newBookingNoteRef.$data.quotation.costs =
                        this.$refs.newBookingNoteRef.$data.costs;
                    this.$refs.newBookingNoteRef.$data.quotation.cost_total =
                        cost_total;
                    this.$refs.newBookingNoteRef.$data.quotation.commission =
                        this.$refs.newBookingNoteRef.$data.commission;
                    this.request_quotation =
                        this.$refs.requestBookingNoteRef.$data.request_quotation;

                    console.log(this.$refs.newBookingNoteRef.$data.quotation);

                    this.$loading.show();

                    // useJwt
                    //     .put("wr1?objectType=EditBooking", {
                    //         id: this.request_quotation.id,
                    //         ...this.$refs.newBookingNoteRef.$data.quotation,
                    //         createdBy: this.userData.username,
                    //         createDate: moment(new Date()).format("DD/MM/YYYY"),
                    //     })
                    //     .then((response) => {
                    //         if (response.data.result == "1") {
                    //             this.activeTabAll = 3;
                    //             this.step = 4;
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         this.$toast({
                    //             component: ToastificationContent,
                    //             props: {
                    //                 title: this.$i18n.t("bookingSaleError"),
                    //                 icon: "AlertTriangleIcon",
                    //                 variant: "danger",
                    //             },
                    //         });
                    //     })
                    //     .finally(() => this.$loading.hide());

                    this.$loading.show();
                  
                    useJwt
                        .post("wr1?objectType=RequestWr1Booking", {
                            request_quotation:
                                this.$refs.requestBookingNoteRef.$data
                                    .request_quotation,
                            quotation: {
                                ...this.$refs.newBookingNoteRef.$data.quotation,
                                createdBy: this.userData.username,
                                createDate: moment(new Date()).format(
                                    "DD/MM/YYYY"
                                ),
                            },
                        })
                        .then((response) => {
                            if (response.data.result == "1") {
                                this.request_quotation.id =
                                    response.data.meta.bookingId;
                                this.valueModal = false;
                                // this.loadBookingNote();
                                this.$toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: "Booking Request Successfully",
                                        icon: "CheckSquareIcon",
                                        variant: "primary",
                                    },
                                });
                            }
                        })
                        .catch((error) => {
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: "Booking Request Error",
                                    icon: "AlertTriangleIcon",
                                    variant: "danger",
                                },
                            });
                        })
                        .finally(() => this.$loading.hide());
                } else if (this.step == 4) {
                    this.valueModal = false;
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: this.$i18n.t("bookingSaleSuccess"),
                            icon: "CheckSquareIcon",
                            variant: "primary",
                        },
                    });
                }
            }
        },
        loadBookingNote() {
            this.booking_note.company_id =
                this.$refs.requestBookingNoteRef.$data.request_quotation.company_id;
            this.booking_note.customer_id =
                this.$refs.requestBookingNoteRef.$data.request_quotation.customer_id;
            this.booking_note.service_type =
                this.$refs.requestBookingNoteRef.$data.request_quotation.service_type;
            this.booking_note.pol_port =
                this.$refs.requestBookingNoteRef.$data.request_quotation.pol_port;
            this.booking_note.pod_port =
                this.$refs.requestBookingNoteRef.$data.request_quotation.pod_port;
            this.booking_note.shipping_line =
                this.$refs.requestBookingNoteRef.$data.request_quotation.shipping_line;
            this.booking_note.eta =
                this.$refs.requestBookingNoteRef.$data.request_quotation.eta;
            this.booking_note.etd =
                this.$refs.requestBookingNoteRef.$data.request_quotation.etd;
            this.booking_note.trong_luong =
                this.$refs.requestBookingNoteRef.$data.request_quotation.trong_luong;
            this.booking_note.so_khoi =
                this.$refs.requestBookingNoteRef.$data.request_quotation.so_khoi;
            this.booking_note.packageNumber =
                this.$refs.requestBookingNoteRef.$data.request_quotation.packageNumber;
            this.booking_note.goods_type =
                this.$refs.requestBookingNoteRef.$data.request_quotation.goods_type;
            this.booking_note.booking_date = moment().format("DD/MM/YY HH:mm");
            this.booking_note.shipping_line =
                this.$refs.requestBookingNoteRef.$data.request_quotation.shipping_line;
            this.booking_note.vessel_name =
                this.$refs.requestBookingNoteRef.$data.request_quotation.vessel_name;

            this.booking_note.place_of_stuffing =
                this.$refs.requestBookingNoteRef.$data.request_quotation.place_of_stuffing;
            this.booking_note.closing_time =
                this.$refs.requestBookingNoteRef.$data.request_quotation.closing_time;
            this.booking_note.cut_si_vgm =
                this.$refs.requestBookingNoteRef.$data.request_quotation.cut_si_vgm;
            this.booking_note.contact =
                this.$refs.requestBookingNoteRef.$data.request_quotation.contact;

            this.booking_note.pol_name =
                this.$refs.requestBookingNoteRef.$data.request_quotation.pol_name;
            this.booking_note.pod_name =
                this.$refs.requestBookingNoteRef.$data.request_quotation.pod_name;
            this.booking_note.sale_id = this.getWr1Username();
            this.countReload++;
            this.reload++;
        },
        assigningBookingNoteToBookingInfo() {
            this.$refs.requestBookingNoteRef.$data.request_quotation.company_id =
                this.booking_note.company_id;

            this.$refs.requestBookingNoteRef.$data.request_quotation.customer_id =
                this.booking_note.customer_id;

            this.$refs.requestBookingNoteRef.$data.request_quotation.service_type =
                this.booking_note.service_type;
            this.$refs.requestBookingNoteRef.$data.request_quotation.pol_port =
                this.booking_note.pol_port;
            this.$refs.requestBookingNoteRef.$data.request_quotation.pod_port =
                this.booking_note.pod_port;
            this.$refs.requestBookingNoteRef.$data.request_quotation.shipping_line =
                this.booking_note.shipping_line;

            this.$refs.requestBookingNoteRef.$data.request_quotation.eta =
                this.booking_note.eta;
            this.$refs.requestBookingNoteRef.$data.request_quotation.etd =
                this.booking_note.etd;

            this.$refs.requestBookingNoteRef.$data.request_quotation.trong_luong =
                this.booking_note.trong_luong;

            this.$refs.requestBookingNoteRef.$data.request_quotation.so_khoi =
                this.booking_note.so_khoi;
            this.$refs.requestBookingNoteRef.$data.request_quotation.packageNumber =
                this.booking_note.packageNumber;
            this.$refs.requestBookingNoteRef.$data.request_quotation.goods_type =
                this.booking_note.goods_type;
        },
        async onServiceType(e) {
            this.$loading.show();
            if (e.service_type) {
                this.request_quotation.service_type =
                    this.$refs.requestBookingNoteRef.$data.request_quotation.service_type;
                this.request_quotation.company_id =
                    this.$refs.requestBookingNoteRef.$data.request_quotation.company_id;
                this.isServiceType = false;
                this.serviceType = e;

                await this.$nextTick();
                // Add my-component from the DOM

                this.isServiceType = true;
            } else {
                this.isServiceType = false;
            }
            this.$loading.hide();
        },
        checkInput(input, words) {
            return words.indexOf(input.split(".").pop()) > -1;
        },
        async removeFile(row) {
            var bookingId =
                this.request_quotation.files.filter((e) => e.path == row.path)
                    .length > 0
                    ? "-1"
                    :  this.request_quotation.id;
            var res = await this.$bvModal.msgBoxConfirm(
                "Are you sure you want to delete this file?",
                { title: "Delete file", size: "sm" }
            );
            if (res) {
                this.document_rows = this.document_rows.filter(
                    (e) => e.path != row.path
                );
                this.request_quotation.files =
                    this.request_quotation.files.filter(
                        (e) => e.path != row.path
                    );
                this.$store.dispatch("attachFile/deleteFile", {
                    bookingId: bookingId,
                    request_quotation_id: this.request_quotation.bookingID,
                    request_quotation_files: this.request_quotation.files,
                    path: row.path,
                });
            }
        },
        saveFile() {
            this.responseFileUp.isRequestFile =
                this.userData.userType ==
                    this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
                this.userData.userType ==
                    this.$Utils.CONSTANTS.USER_TYPE_O.Admin
                    ? "0"
                    : "1";
            this.responseFileUp.bookingId = this.request_quotation.id;
            this.responseFileUp.size = `${this.file.size}`;
            this.responseFileUp.notes = this.notes;

            this.$store.dispatch("attachFile/upFile", this.responseFileUp);
            this.responseFileUp.date = moment(new Date()).format(
                "DD/MM/YYYY HH:mm:ss"
            );

            this.responseFileUp.text = this.responseFileUp.name;
            this.responseFileUp.download_path =
                $ctx.API_URL +
                "uploadFile/" +
                this.responseFileUp.path +
                "?apiKey=" +
                localStorage.getItem("accessToken") +
                "&name=" +
                this.responseFileUp.name;
            this.responseFileUp.fullName = this.userData.fullName;
            this.document_rows.push(this.responseFileUp);
            this.$bvModal.hide("file-notes");
        },
        uploadSuccess: function (file, res) {
            this.responseFileUp = "";
            this.file = "";

            if (file && res.message == "success!") {
                this.nameFile = res.result.name;
                this.responseFileUp = res.result;
                this.$bvModal.show("file-notes");
                this.file = file;
            }
        },
        viewFile(row) {
            this.type = this.checkInput(row.name, this.typeViewImg);
            this.$store
                .dispatch("attachFile/viewFile", {
                    id: row.path,
                    name: row.name,
                })
                .then((rs) => {
                    if (rs.data.message == "success!") {
                        this.base64 = rs.data.result;
                        this.$bvModal.show("view-file");
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: rs.data.message,
                                icon: "AlertTriangleIcon",
                                variant: "danger",
                            },
                        });
                    }
                });
        },
        vdropzoneError(file, errorMessage) {
            this.$refs.addFile.removeFile(file);
            if (errorMessage.includes("Max filesize: 10MiB")) {
                return this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.$i18n.t("uploadSizeErrorFile"),
                        icon: "AlertTriangleIcon",
                        variant: "danger",
                    },
                });
            }

            if (errorMessage.includes("You can not upload any more files.")) {
                return this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.$i18n.t("uploadLimitErrorFile"),
                        icon: "AlertTriangleIcon",
                        variant: "danger",
                    },
                });
            }
        },
        postBookingNote() {
            return new Promise((resolve, reject) => {
                useJwt
                    .post("bookingNoteFromBooking", {
                        booking_id: this.request_quotation.id,
                        ...this.booking_note,
                        eta: this.booking_note.eta ? this.booking_note.eta : "",
                        etd: this.booking_note.etd ? this.booking_note.etd : "",
                    })
                    .then((response) => {
                        if (response.data.message == "success!") {
                            resolve(response.data.meta.bookingNoteId);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch((error) => {
                        resolve(false);
                    })
                    .finally(() => this.$loading.hide());
            });
        },
    },
};
</script>

<style>
.custom-bg {
    background: red;
}

.nav-pills {
    margin-bottom: 0;
}
.card-header {
    background-color: white;
    border-bottom: none;
}
.hide_select {
    width: 100% !important;
}
.custom-col {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
}
.card-header ul {
    margin-left: 0rem;
    display: flex;
    gap: 10rem;
}

.nav-pills .nav-link {
    font-size: 18px;
}
.custom_btn_booking {
    padding: 0.6rem 3rem;
    background: #2b938c;
    border: none;
    color: white;
    font-size: large;
    border-radius: 1rem;
    margin-bottom: 2rem;
    margin-top: 2rem;
}
.custom_btn_booking:hover {
    opacity: 0.7;
}
.container_btn {
    margin-top: -2rem;
    gap: 3.5rem;
    margin-right: 2rem;
    display: flex;
    justify-content: end;
}
.nav-pills .nav-link{
    width: 200px;
    height: 40px;
    padding: 1rem 1rem;
    line-height: inherit;
}
.card-header{
    .nav{
        gap:4.2rem
    }
}
.custom_text_coming{
    color:#000000;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:2rem;
    margin-top:4rem;
}
</style>
